import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = {
  key: 0,
  class: "modal-dialog"
}
const _hoisted_4 = {
  key: 1,
  class: "modal-dialog modal-lg modal-dialog-scrollable"
}
const _hoisted_5 = { class: "modal-content" }
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = {
  class: "alert alert-danger text-dark",
  role: "alert"
}
const _hoisted_8 = {
  key: 0,
  class: "card"
}
const _hoisted_9 = { class: "card-header" }
const _hoisted_10 = { class: "list-group list-group-flush" }
const _hoisted_11 = { class: "text-primary" }
const _hoisted_12 = { class: "text-muted" }
const _hoisted_13 = {
  key: 2,
  class: "modal-dialog"
}
const _hoisted_14 = { class: "modal-content" }
const _hoisted_15 = { class: "modal-body" }

import { computed, toRef } from 'vue'
    import type { PropType } from 'vue'
    import type { DependentEntityInfo } from "@common/types"
    import { dynamicUiRoutes } from "@common/dynamicUiRoutes"
    import type { CriterionDeleterViewModel } from "@Criteria/Hierarchies/Components/CriterionDeleter"
    import { useRoute } from 'vue-router'

    // ---------------- props / emits ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CriterionDeleter',
  props: {
        viewModel: {
            type: Object as PropType<CriterionDeleterViewModel>,
            required: true
        }
    },
  emits: ["delete-criterion"],
  setup(__props, { emit: __emit }) {

    const props = __props

    const emit = __emit

    // ---------------- state ----------------

    const vm = toRef(props, 'viewModel')
    const route = useRoute()

    // ---------------- computed ----------------

    const opened = computed(() => vm.value.isOpen)
    const initialized = computed(() => vm.value.data != null)

    const criterionId = computed(() => vm.value.criterionId)
    const hasDependants = computed(() => vm.value.data?.HasDependants ?? false)
    const criterionName = computed(() => vm.value.data?.Name ?? '')
    const dependenciesCount = computed(() => vm.value.data?.DependenciesCount ?? 0)
    const weightedScores = computed(() => vm.value.data?.WeightedScores ?? [])

    // ---------------- helpers ----------------

    function url_EditWeightedScorePage(e: DependentEntityInfo)
    {
        return dynamicUiRoutes.Criteria_EditWeightedScorePage2(
            route,
            e.WorkspaceId,
            e.TchProjectId,
            Number.parseInt(e.Id)
        )
    }

    // ---------------- actions ----------------

    function emitDeleteCriterion()
    {
        emit("delete-criterion", criterionId.value!)
    }

    function close()
    {
        vm.value.close()
    }

return (_ctx: any,_cache: any) => {
  const _directive_sanitizedHref = _resolveDirective("sanitizedHref")!

  return (opened.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (!initialized.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", { class: "modal-content" }, [
                  _createElementVNode("div", { class: "modal-header" }, [
                    _cache[0] || (_cache[0] = _createElementVNode("h5", { class: "modal-title" }, "Delete criterion", -1 /* CACHED */)),
                    _createElementVNode("button", {
                      type: "button",
                      class: "close",
                      onClick: close
                    }, "×")
                  ]),
                  _cache[1] || (_cache[1] = _createElementVNode("div", { class: "modal-body" }, [
                    _createElementVNode("h4", null, [
                      _createElementVNode("i", { class: "fa fa-spinner fa-spin" }),
                      _createTextVNode(" Checking dependencies...")
                    ])
                  ], -1 /* CACHED */)),
                  _createElementVNode("div", { class: "modal-footer" }, [
                    _createElementVNode("button", {
                      type: "button",
                      onClick: close,
                      class: "btn btn-outline-secondary"
                    }, "Cancel")
                  ])
                ])
              ]))
            : _createCommentVNode("v-if", true),
          (initialized.value && hasDependants.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", { class: "modal-header" }, [
                    _cache[2] || (_cache[2] = _createElementVNode("h5", { class: "modal-title" }, "Delete criterion", -1 /* CACHED */)),
                    _createElementVNode("button", {
                      type: "button",
                      class: "close",
                      onClick: close
                    }, "×")
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _cache[6] || (_cache[6] = _createElementVNode("h5", { class: "alert-heading" }, "Cannot delete this criterion", -1 /* CACHED */)),
                      _createElementVNode("p", null, [
                        _cache[3] || (_cache[3] = _createTextVNode(" The criterion '", -1 /* CACHED */)),
                        _createElementVNode("strong", null, _toDisplayString(criterionName.value), 1 /* TEXT */),
                        _cache[4] || (_cache[4] = _createTextVNode("' is used in ", -1 /* CACHED */)),
                        _createElementVNode("strong", null, _toDisplayString(dependenciesCount.value), 1 /* TEXT */),
                        _cache[5] || (_cache[5] = _createTextVNode(" places. To delete this criterion, first remove it from where it is used. ", -1 /* CACHED */))
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      (weightedScores.value.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, [
                              _cache[7] || (_cache[7] = _createTextVNode(" Weighted scores (", -1 /* CACHED */)),
                              _createElementVNode("span", null, _toDisplayString(weightedScores.value.length), 1 /* TEXT */),
                              _cache[8] || (_cache[8] = _createTextVNode(") ", -1 /* CACHED */))
                            ]),
                            _createElementVNode("ul", _hoisted_10, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(weightedScores.value, (ws) => {
                                return (_openBlock(), _createElementBlock("li", {
                                  class: "list-group-item",
                                  key: ws.Id
                                }, [
                                  _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_11, [
                                    _createTextVNode(_toDisplayString(ws.Name), 1 /* TEXT */)
                                  ])), [
                                    [_directive_sanitizedHref, url_EditWeightedScorePage(ws)]
                                  ]),
                                  _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                                  _createElementVNode("small", _hoisted_12, _toDisplayString(ws.Path), 1 /* TEXT */)
                                ]))
                              }), 128 /* KEYED_FRAGMENT */))
                            ])
                          ]))
                        : _createCommentVNode("v-if", true)
                    ])
                  ]),
                  _createElementVNode("div", { class: "modal-footer" }, [
                    _createElementVNode("button", {
                      type: "button",
                      onClick: close,
                      class: "btn btn-outline-secondary"
                    }, "Close")
                  ])
                ])
              ]))
            : _createCommentVNode("v-if", true),
          (initialized.value && !hasDependants.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", { class: "modal-header bg-danger text-white" }, [
                    _cache[10] || (_cache[10] = _createElementVNode("h5", { class: "modal-title" }, "Delete criterion", -1 /* CACHED */)),
                    _createElementVNode("button", {
                      type: "button",
                      class: "close text-white",
                      onClick: close
                    }, "×")
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _cache[15] || (_cache[15] = _createElementVNode("h4", null, "Are you sure you want to delete this criterion?", -1 /* CACHED */)),
                    _createElementVNode("p", null, [
                      _cache[11] || (_cache[11] = _createTextVNode("You are about to delete '", -1 /* CACHED */)),
                      _createElementVNode("strong", null, _toDisplayString(criterionName.value), 1 /* TEXT */),
                      _cache[12] || (_cache[12] = _createTextVNode("'. Deleting a criterion will also delete its ", -1 /* CACHED */)),
                      _cache[13] || (_cache[13] = _createElementVNode("strong", null, "sub-criteria", -1 /* CACHED */)),
                      _cache[14] || (_cache[14] = _createTextVNode(". This can't be undone.", -1 /* CACHED */))
                    ])
                  ]),
                  _createElementVNode("div", { class: "modal-footer" }, [
                    _createElementVNode("button", {
                      type: "button",
                      onClick: emitDeleteCriterion,
                      class: "btn btn-danger"
                    }, "Delete"),
                    _createElementVNode("button", {
                      type: "button",
                      onClick: close,
                      class: "btn btn-outline-secondary"
                    }, "Cancel")
                  ])
                ])
              ]))
            : _createCommentVNode("v-if", true)
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})